import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { APP_STORE_URL, PLAY_STORE_URL } from '../storeLinks';

const JoinWallet = () => {
    const { token } = useParams();

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            // Play Install Referrer hands the token to the app on its first launch.
            const referrer = encodeURIComponent(`invite=${token}`);
            window.location.replace(`${PLAY_STORE_URL}&referrer=${referrer}`);
            return;
        }

        window.location.replace(APP_STORE_URL);
    }, [token]);

    return null;
};

export default JoinWallet;
